import { Injectable, Provider } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Traducción ES de labels de `mat-paginator`.
 * Registrar una vez en bootstrap (`provideSpanishMatPaginatorIntl()`).
 */
@Injectable()
export class SpanishMatPaginatorIntl extends MatPaginatorIntl {
	override itemsPerPageLabel = 'Elementos por página';
	override nextPageLabel = 'Página siguiente';
	override previousPageLabel = 'Página anterior';
	override firstPageLabel = 'Primera página';
	override lastPageLabel = 'Última página';

	override getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0 || pageSize === 0) {
			return `0 de ${length}`;
		}

		const start = page * pageSize;
		const end = Math.min(start + pageSize, length);
		return `${start + 1} – ${end} de ${length}`;
	};
}

export function provideSpanishMatPaginatorIntl(): Provider {
	return { provide: MatPaginatorIntl, useClass: SpanishMatPaginatorIntl };
}
